import bibleBookList from "../data/BookChapterList.json"
import DBLBookList from "../data/DBLBooks.json"

export default function getStandardVerse(versification, ref) {
  if (!versification) return ref
  // console.log("[getStandardVerse]", versification, ref)
  const refSplit = ref.split("-")
  const DBLBook = bibleBookList[refSplit[0]].YV
  // console.log(`${DBLBook}-${refSplit[1]}-${refSplit[2]}`)
  if (versification[`${DBLBook}-${refSplit[1]}-${refSplit[2]}`]) {
    // console.log(versification[`${DBLBook}-${refSplit[1]}-${refSplit[2]}`])
    const newRef = versification[`${DBLBook}-${refSplit[1]}-${refSplit[2]}`]
    const newRefSplit = newRef.split("-")
    const DJHBook = DBLBookList[newRefSplit[0]]
    // console.log(`${DJHBook}-${newRefSplit[1]}-${newRefSplit[2]}`)
    return `${DJHBook}-${newRefSplit[1]}-${newRefSplit[2]}`
  }
  return ref
}
